import {
  Window as BrowserWindow,
  WindowInteractionError,
} from '@execonline-inc/browser-window.private';
import { InvalidUrlError, putPathname, windowLocation } from '@execonline-inc/url';
import { noop } from '@kofno/piper';
import { Task } from 'taskarian';
import { callApi } from '../../../../Appy';
import { findLinkT } from '../../../../LinkyLinky';
import { Link } from '../../../../Resource/Types';
import { fromNullableT } from '../../../../TaskExt';
import { learningCollectionEditFormResourceDecoder } from '../Decoders';
import { editTemplatesCheck } from '../Edit/Store/Reactions';
import { LearningCollectionEditFormResource } from '../Edit/Store/Types';
import LearningCollectionStore from '../Store';
import { Creating, LearningCollectionError } from '../Types';
import learningCollectionEncoder from './LearningCollectionEncoder';
import { Maybe } from 'maybeasy';
import { FileMetaData } from '../Edit/CurrentCollectionStep/Details/S3ImageUpload/Types';

const createLearningCollection = (
  store: LearningCollectionStore,
  state: Creating,
  fileMetaData: Maybe<FileMetaData>,
) =>
  Task.succeed<LearningCollectionError, ReadonlyArray<Link>>(store.links)
    .andThen(findLinkT('create'))
    .andThen(
      callApi(
        learningCollectionEditFormResourceDecoder,
        learningCollectionEncoder(
          store,
          state,
          fileMetaData,
          state.learningCollectionFormResource.payload.warningStatus,
        ),
      ),
    );

const getErrorType =
  (store: LearningCollectionStore, state: Creating) =>
  (error: LearningCollectionError): Task<LearningCollectionError, void> =>
    fromNullableT(state.learningCollectionFormResource.templates.self).map((template) =>
      store.newFormSubmissionError(state.learningCollectionFormResource, error, template),
    );

const editPath = (id: number) => `/learning_collections/${id}/edit/customize?celebrate=true`;

const redirectToEdit = (resource: LearningCollectionEditFormResource) => {
  Task.succeed<InvalidUrlError | WindowInteractionError, {}>({})
    .andThen(windowLocation)
    .map(putPathname(editPath(resource.payload.id)))
    .andThen((url) => BrowserWindow.locationReplace(url.href))
    .fork(() => console.warn('learning collection create - unable to redirect to edit'), noop);
};

const updateCollectionsStoreAndTransitionToEdit =
  (store: LearningCollectionStore) => (resource: LearningCollectionEditFormResource) => {
    editTemplatesCheck(resource).fork(store.templateLoadError, () => {
      redirectToEdit(resource);
    });
  };

const create = (
  store: LearningCollectionStore,
  state: Creating,
  fileMetaData: Maybe<FileMetaData>,
) =>
  createLearningCollection(store, state, fileMetaData)
    .map(updateCollectionsStoreAndTransitionToEdit(store))
    .orElse(getErrorType(store, state))
    .fork(store.templateLoadError, noop);

export default create;
